import licenseType from 'models/licenseType';

export const isAcademicFull = user =>
  user?.licenses?.some(x => x.type === licenseType.academic && !x.demoMode);

export const isIndustryFull = user =>
  user?.licenses?.some(x => x.type === licenseType.industry && !x.demoMode);

export const isAcademicTrial = user =>
  user?.licenses?.some(x => x.type === licenseType.academic && x.demoMode);

export const isIndustryTrial = user =>
  user?.licenses?.some(x => x.type === licenseType.industry && x.demoMode);

export const noIndustryLicence = user =>
  !isIndustryFull(user) && !isIndustryTrial(user);
export const noAcademicLicence = user =>
  !isAcademicFull(user) && !isAcademicTrial(user);

export const isFullTrial = user =>
  (isAcademicTrial(user) && !isIndustryFull(user)) ||
  (isIndustryTrial(user) && !isAcademicFull(user));

export const hasFullLicense = user =>
  isAcademicFull(user) || isIndustryFull(user);

const requirementToLicenses = {
  ValidIndustryLicence: [licenseType.industry],
  ValidAcademicLicence: [licenseType.academic],
};

/**
 * Checks if a user meets the license requirements for a column.
 * @param {string[]} requirements - Array of requirement strings from ColumnMetadata
 * @param {(licenses: number[], allowForTrials?: boolean) => boolean} hasLicense - License checker from useAuth
 * @returns {boolean}
 */
export const meetsColumnRequirements = (requirements, hasLicense) => {
  if (!requirements || requirements.length === 0) return true;

  for (const req of requirements) {
    const licenses = requirementToLicenses[req];
    if (licenses === undefined) continue;
    if (hasLicense(licenses, true)) return true;
  }

  const hasKnownRequirements = requirements.some(
    r => requirementToLicenses[r] !== undefined
  );
  return !hasKnownRequirements;
};
